/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 22:41:28
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-25 22:41:47
 * @FilePath: /unifyxp-v2-store-portal/src/tools/event.ts
 */
import { EventEmitter } from 'events';
export default new EventEmitter();
